import { render, staticRenderFns } from "./cropperImages.vue?vue&type=template&id=48c68970"
import script from "./cropperImages.vue?vue&type=script&lang=js"
export * from "./cropperImages.vue?vue&type=script&lang=js"
import style0 from "./cropperImages.vue?vue&type=style&index=0&id=48c68970&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports